module.exports = __webpack_public_path__ + "static/youtube-thumbnail-c1d3602eec2e7e4e18c61f0201ab8a06.jpg";